<template>
  <v-row align="center" justify="center">
    <v-col cols="12" sm="8">
      <v-card>
        <v-card-title class="d-flex justify-space-between">
          <span>
            User list
          </span>
          <v-btn
            small
            color="primary"
            :to="{ name: $routes.admin.user.createRoute.name }"
          >
            Create user
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :loading="loading"
            :headers="tableColumns"
            :items="users"
          >
            <template v-slot:item.action="{ item }">
              <v-btn icon @click="editUser(item)">
                <font-awesome-icon icon="pencil-alt"></font-awesome-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import * as User from "../../../../api/user.api.js";
import ContentLoader from "../../../mixins/ContentLoader.js";

export default {
  name: "UserIndex",
  mixins: [ContentLoader],
  data() {
    return {
      users: []
    };
  },
  computed: {
    tableColumns() {
      return [
        {
          value: "id",
          text: "#"
        },
        {
          value: "username",
          text: "Username"
        },
        {
          value: "email",
          label: "Email"
        },
        {
          text: "Actions",
          value: "action"
        }
      ];
    }
  },
  async mounted() {
    this.$startLoading();

    try {
      const {
        data: { users }
      } = await User.fetchUsers();

      this.users = users;

      await this.$nextTick();
    } finally {
      this.$finishedLoading();
    }
  },
  methods: {
    editUser({ id }) {
      this.$router.push({
        name: this.$routes.admin.user.editRoute.name,
        params: { id }
      });
    }
  }
};
</script>
